module.exports = __webpack_public_path__ + "img/default_img_3.2d3693ef.png";